/// <reference path="Utilities/_reference.ts" />

module YVR.Navigation  {
	// Dependencies
	import mq = YVR.Utilities.MediaQueries;

	let mobileNavIsOpen = false;

	// CSS classes
	const classes = {
		navigation: 'yvr-navigation-secondary',
		button: 'yvr-navigation-secondary__button',
		navLink: 'yvr-navigation-secondary__link',
		dropdown: 'yvr-navigation-secondary__dropdown',
		subnavLink: 'yvr-navigation-secondary__dropdown-link',
		dropdownLink: 'yvr-navigation-secondary__dropdown__link',
		item: 'yvr-navigation-secondary__item',
		languages: 'yvr-languages',
		list: 'yvr-navigation-secondary__list',
		scroll: 'yvr-navigation-secondary__scroll',
		scrollmenu: 'yvr-navigation-secondary__scroll--menu',
		search: 'yvr-search-box',
		utility: 'yvr-navigation-utility'
	};

	// Cached jQuery elements
	const elements = {
		button: $(`.${classes.button}`),
		html: $('html'),
		list: $(`.${classes.list}`),
		footer: $('.yvr-footer__container'),
		navLinks: $(`.${classes.navLink}`),
		dropdown: $(`.${classes.dropdown}`),
		scroll: $(`.${classes.scroll}`),
		scrollmenu: $(`.${classes.scrollmenu}`)
	};

	let aria = aria || {};
	aria.Utils = aria.Utils || {};

	aria.Utils.isFocusable = function (element) {
		if (element.tabIndex > 0 || (element.tabIndex === 0 && element.getAttribute('tabIndex') !== null)) {
			return true;
		}

		if (element.disabled) {
			return false;
		}

		switch (element.nodeName) {
			case 'A':
				return !!element.href && element.rel != 'ignore';
			case 'INPUT':
				return element.type != 'hidden' && element.type != 'file';
			case 'BUTTON':
			case 'SELECT':
			case 'TEXTAREA':
				return true;
			default:
				return false;
		}
	};
	/**
	 * @desc
	 *  Key code constants
	 */
	aria.KeyCode = {
		BACKSPACE: 8,
		TAB: 9,
		RETURN: 13,
		ESC: 27,
		SPACE: 32,
		PAGE_UP: 33,
		PAGE_DOWN: 34,
		END: 35,
		HOME: 36,
		LEFT: 37,
		UP: 38,
		RIGHT: 39,
		DOWN: 40,
		DELETE: 46
	};


	/**
	 * Event bindings for various user interaction.
	 */
	function eventBindings() {
		// Open and close the navigation on button click for narrow devices
		elements.button.on('click', e => {
			e.preventDefault();
			if ($(e.target).attr('aria-expanded') == 'false') {
				$(e.target).attr('aria-expanded', 'true');
			} else {
				$(e.target).attr('aria-expanded', 'false');

			}

			navigationToggle(e);
		});

		// Open and close the navigation on button click for narrow devices
		elements.scrollmenu.on('click', e => {
			e.preventDefault();
			if ($(e.target).attr('aria-expanded') == 'false') {
				$(e.target).attr('aria-expanded', 'true');
			} else {
				$(e.target).attr('aria-expanded', 'false');

			}

			navigationToggle(e);
		});

		// Open and close the navigation on button click for narrow devices
		elements.navLinks.on('click', e => {

			const $target = $(e.currentTarget);

			// If link has no sublinks, allow normal navigation
			if ($target.hasClass('yvr-navigation-secondary__no-sublinks')) {
				return;
			}

			//If screen size is mobile size
			if ($(window).width() < 992) {

				let id = '#' + e.target.id;
				let openId = '#drop_' + e.target.id;

				//if mobile nav isn't open, open it
				if ($(openId).hasClass(`${classes.dropdown}--active`)) {
				} else if (mobileNavIsOpen) {
					e.preventDefault();
					//resetMobileNav();
					openMobileNavDropdown(id, openId);
				}
			}
		});

		// Show navigation dropdowns on keyboard focuses
		elements.list.on('focus', `.${classes.dropdownLink}`, function (e) {
			$(this).parents(`.${classes.item}`).addClass(`${classes.item}--active`);

		});

		//elements.list.on('mouseover', `.${classes.navLink}`, function (e) {
		//	console.log('focus detected');
		//	var downlink = $(e.target).next();
		//	console.log(downlink);
		//	var subnavlinks = downlink.find(`.${classes.subnavLink}`);
		//	console.log(subnavlinks);
		//	downlink.find('yvr-navigation-secondary__dropdown-list').attr('aria-hidden', 'true');
		//	subnavlinks.attr('tabindex', -1);
		//});

		elements.list.on('keydown', `.${classes.navLink}`, function (e) {
			switch (e.keyCode) {
				case aria.KeyCode.DOWN:
					e.preventDefault();
					let downlink = $(e.target).next();
					let listGroup = downlink.find('yvr-navigation-secondary__dropdown-list').attr('aria-hidden', 'false');
					let subnavlinks = downlink.find(`.${classes.subnavLink}`);
					subnavlinks.attr('tabindex', 0);
					let firstlink = downlink.find(`.${classes.subnavLink}`).first();
					firstlink.focus();
					break;
				case aria.KeyCode.UP:
					e.preventDefault();

				break;
			}
		});

		elements.list.on('keydown', `.${classes.subnavLink}`, function (e) {
			switch (e.keyCode) {
				case aria.KeyCode.DOWN:
					e.preventDefault();
					let parent = $(e.target).parent();
					let next = parent.next();
					let nextlink = next.find(`.${classes.subnavLink}`).first();
					nextlink.focus();
					break;

				case aria.KeyCode.UP:
					e.preventDefault();
					let parent = $(e.target).parent();
					let next = parent.prev();
					let prevlink = next.find(`.${classes.subnavLink}`).first();
					if (prevlink.length == 0) {
						prevlink = parent.parent().parent().prev();
						let subnavlinks = prevlink.next().find(`.${classes.subnavLink}`);
						subnavlinks.attr('tabindex', -1);
					}
					prevlink.focus();
					break;
			}
		});


		// Hide navigation dropdowns on keyboard blurs
		elements.list.on('blur', `.${classes.dropdownLink}`, function (e) {
			$(this).parents(`.${classes.item}`).removeClass(`${classes.item}--active`);
		});

		// When leaving the `sm` state...
		elements.html.on(mq.changeEvent, e => {
			if ((e as mq.IMediaQueryEventObject).state === 'sm' && (e as mq.IMediaQueryEventObject).action === 'exit') {
				navigationRemove();
			}
		});
		elements.footer.on('focus', '.yvr-footer__heading-link', function (e) {
			let downlink = $(e.target).parent().next();
			let subnavlinks = downlink.find('.yvr-footer__link');
			subnavlinks.attr('tabindex', -1);
		});

		elements.footer.on('keydown', '.yvr-footer__heading-link', function (e) {
			switch (e.keyCode) {
				case aria.KeyCode.DOWN:
					e.preventDefault();
					let downlink = $(e.target).parent().next();
					let subnavlinks = downlink.find('.yvr-footer__link');
					subnavlinks.attr('tabindex', 0);
					let firstlink = downlink.find('.yvr-footer__link').first();
					firstlink.focus();
					break;
				case aria.KeyCode.UP:
					e.preventDefault();

					break;
			}
		});
		elements.footer.on('keydown', '.yvr-footer__link', function (e) {
			switch (e.keyCode) {
				case aria.KeyCode.DOWN:
					e.preventDefault();
					let parent = $(e.target).parent();
					let next = parent.next();
					let nextlink = next.find('.yvr-footer__link').first();
					nextlink.focus();
					break;

				case aria.KeyCode.UP:
					e.preventDefault();
					let parent = $(e.target).parent();
					let next = parent.prev();
					let prevlink = next.find('.yvr-footer__link').first();
					if (prevlink.length == 0) {
						prevlink = parent.parent().prev();
						let subnavlinks = prevlink.next().find('.yvr-footer__link');
						subnavlinks.attr('tabindex', -1);
					}
					prevlink.focus();
					break;
			}
		});

		elements.html.on('keydown', function (e) {
			switch (e.keyCode) {
				case aria.KeyCode.TAB:
					elements.html.addClass('enable-outline');
					break;
			}
		});

	}


	/**
	 * Toggle off and on the navigation for narrow screens
	 * @param {obj} e A jQuery event object
	 */
	function navigationToggle(e) {
		const parent = $(e.target).parents(`.${classes.navigation}`);

		parent.toggleClass(`${classes.navigation}--active`);
		parent.find(`.${classes.button}`).toggleClass(`${classes.button}--active`);
		parent.find(`.${classes.list}`).toggleClass(`${classes.list}--active`);
		parent.find(`.${classes.search}`).toggleClass(`${classes.search}--active`);
		parent.find(`.${classes.languages}`).toggleClass(`${classes.languages}--active`);
		parent.find(`.${classes.utility}`).toggleClass(`${classes.utility}--active`);
		parent.find(`.${classes.scroll}`).toggleClass(`${classes.scroll}--active`);
		parent.find(`.${classes.scrollmenu}`).toggleClass(`${classes.scrollmenu}--active`);

		resetMobileNav();
		if (mobileNavIsOpen) {
			mobileNavIsOpen = false;
		} else {
			mobileNavIsOpen = true;
		}
	}


	/**
	 * Turn off the navigation for narrow screens
	 */
	function navigationRemove() {
		const parent = $(`.${classes.navigation}`);

		parent.removeClass(`${classes.navigation}--active`);
		parent.find(`.${classes.button}`).removeClass(`${classes.button}--active`);
		parent.find(`.${classes.list}`).removeClass(`${classes.list}--active`);
		parent.find(`.${classes.search}`).removeClass(`${classes.search}--active`);
		parent.find(`.${classes.languages}`).removeClass(`${classes.languages}--active`);
		parent.find(`.${classes.utility}`).removeClass(`${classes.utility}--active`);
	}

	/**
	 * Open mobile nav sub menu
	 */
	function openMobileNavDropdown(id, openId) {
		$(openId).toggleClass(`${classes.dropdown}--active`);
		//$(id).get(0).scrollIntoView({
		//	behavior: 'smooth',
		//	block: 'start'
		//});
		//window.scrollBy(0, -60);

	}

	/**
	 * Reset mobile navigation sub menus
	 */
	function resetMobileNav() {

		const parent = $(`.${classes.navigation}`);

		parent.find(`.${classes.dropdown}`).removeClass(`${classes.dropdown}--active`);
	}

	$.fn.isExternal = function () {
		let host = window.location.host;
		let link = $('<a>', {
			href: this.attr('href')
		})[0].hostname;
		return (link !== host);
	};

	function checkForExternals() {
		$('#maincontent a').each(function () {
			if ($(this).isExternal()) {
				$(this).addClass('external-link');

			}
		});
	}

	function cleanAltTextInSecondary() {
		$('.yvr-navigation-secondary__link img').each(function () {
			$(this).attr('alt', '');
		});
	}


	function main() {
		eventBindings();
		checkForExternals();
		cleanAltTextInSecondary();
	}

	main();
}
